import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=b40dbb34&scoped=true"
import script from "./infrastructure.vue?vue&type=script&lang=js"
export * from "./infrastructure.vue?vue&type=script&lang=js"
import style0 from "./infrastructure.vue?vue&type=style&index=0&id=b40dbb34&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40dbb34",
  null
  
)

export default component.exports